import * as React from "react";

import MyLocationTwoTone from "@material-ui/icons/MyLocationTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import Topic from "~/components/CustomerSupport/Topic";
import Loader from "~/components/TrackTrace/Loader";
import ShipmentProgressbar from "~/components/TrackTrace/ShipmentProgressbar";
import { ShipmentState } from "~/components/TrackTrace/types";
import { IOrder, IShipment } from "~/graphql/queries/order/orderByName";
import { ShipmentStatus } from "~/graphql/queries/shipment/shipmentsByIds";
import SHIPMENT_STATE_DESCRIPTIONS from "~/helpers/shipmentStateDescriptions";
import { StyledCard as Card } from "~/layouts/StyledCard";
import NexusProductsDetail from "./NexusProductsDetail";
import TrackNowLink from "./TrackNowLink";

interface IProps {
  order: IOrder;
}

class NexusShipmentDetail extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, order } = this.props;
    const { shipments } = order;

    if (!shipments) {
      return <Loader />;
    }

    if (shipments.edges.length === 0) {
      const Description = SHIPMENT_STATE_DESCRIPTIONS[ShipmentState.PROCESSING];

      return (
        <Card>
          <Topic
            icon={MyLocationTwoTone}
            title={t("title")}
            description={<Description order={order} />}
          />
          <ShipmentProgressbar state={ShipmentState.PROCESSING} />
        </Card>
      );
    }

    return (
      <>
        {shipments.edges.map(({ node: shipment }) => {
          const { trackingNumber, id, orderLineItems } = shipment;

          const shipmentState = shipment
            ? this.mapShipmentStatus(shipment)
            : ShipmentState.PROCESSING;

          const Description = SHIPMENT_STATE_DESCRIPTIONS[shipmentState];

          return (
            <React.Fragment key={id}>
              <Card>
                <Topic
                  icon={MyLocationTwoTone}
                  title={t("title")}
                  description={<Description order={order} />}
                />

                <ShipmentProgressbar state={shipmentState} />

                <h4>Tracking Number: {trackingNumber}</h4>

                <NexusProductsDetail orderLineItems={orderLineItems} />
              </Card>

              <TrackNowLink trackingIds={trackingNumber} />
            </React.Fragment>
          );
        })}
      </>
    );
  }

  private mapShipmentStatus(shipment: IShipment): ShipmentState {
    if (!shipment.shipmentEvents.length) {
      return ShipmentState.PROCESSING;
    }

    const KNOWN_STATUSES = [
      "ARRIVED_DESTINATION_COUNTRY",
      "DEPARTED_ORIGIN_COUNTRY",
      "DELIVERED",
      "IN_TRANSIT",
      "PICKED_UP_BY_CARRIER"
    ];

    const lastStatusEvent = KNOWN_STATUSES.includes(shipment.lastEventStatus)
      ? shipment.lastEventStatus
      : null;

    if (!lastStatusEvent) {
      return ShipmentState.PROCESSING;
    }

    switch (lastStatusEvent) {
      case ShipmentStatus.DEPARTED_ORIGIN_COUNTRY:
        return ShipmentState.DEPART_ORIGIN_COUNTRY;
      case ShipmentStatus.ARRIVED_DESTINATION_COUNTRY:
        return ShipmentState.ARRIVE_DESTINATION_COUNTRY;
      case ShipmentStatus.DELIVERED:
        return ShipmentState.DELIVERY;
    }
    return ShipmentState.DEPART_ORIGIN_COUNTRY;
  }
}

export default withTranslation("trackTrace")(NexusShipmentDetail);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/NexusShipmentDetail.tsx